import { createMuiTheme, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, makeStyles, MuiThemeProvider, withStyles } from '@material-ui/core';
import React from 'react';
import { Magnetic as Mi } from "../../../styles";
import styled from '@emotion/styled';
const useStyles = makeStyles(theme => ({
    panelHeading: {
        height: Mi.twistyBaseMinHeight,
        minHeight: Mi.twistyBaseMinHeight,
        display: 'flex',
        alignItems: 'center'
    },
    headingLabel: (props) => ({
        fontSize: props.fontSize ? props.fontSize : Mi.twistyBaseFontSize,
        color: Mi.twistyBaseColor,
        fontWeight: Mi.twistyBaseFontWeight
    }),
    headingSubLabel: (props) => ({
        fontSize: props.fontSize ? props.fontSize : Mi.twistyBaseSubHeaderFontSize,
        fontWeight: Mi.twistyBaseSubHeaderFontWeight,
        color: Mi.twistyBaseColor,
        marginLeft: Mi.spacer08,
        whiteSpace: 'nowrap'
    })
}));
const TwistyExpansionPanel = withStyles({
    root: {
        boxShadow: Mi.twistyBaseBoxShadow,
        '&:before': {
            background: 'none'
        },
        '&$expanded': {
            margin: '0'
        }
    },
    expanded: {}
})(ExpansionPanel);
const TwistyExpansionPanelSummary = withStyles({
    expandIcon: {
        '&$expanded': {
            transform: 'rotate(90deg)'
        },
        fontSize: Mi.twistyBaseIconSize,
        padding: Mi.twistyBaseIconPadding,
        order: -1,
        color: Mi.twistyBaseColor
    },
    root: {
        justifyContent: 'flex-start',
        backgroundColor: Mi.twistyBaseBackgroundColor,
        '&:hover': {
            background: Mi.twistyRowBackgroundHover
        },
        '&:active': {
            backgroundColor: Mi.twistyRowBackgroundActive
        },
        '&$expanded': {
            minHeight: Mi.twistyBaseMinHeight
        }
    },
    content: {
        width: 0,
        alignItems: 'baseline'
    },
    expanded: {}
})(ExpansionPanelSummary);
const theme = createMuiTheme({
    props: {
        MuiButtonBase: {
            disableRipple: true
        }
    }
});
const StyledExpansionPanel = withStyles({
    root: {
        backgroundColor: 'inherit',
        boxShadow: 'none',
        position: 'static',
        '&$expanded': {
            margin: 'auto'
        }
    },
    expanded: {}
})(ExpansionPanel);
const StyledExpansionPanelSummary = withStyles({
    expandIcon: {
        '&$expanded': {
            transform: 'rotate(90deg)'
        },
        fontSize: Mi.fontSize16,
        padding: Mi.spacer12,
        order: -1,
        color: Mi.colorBrand50
    },
    expanded: {},
    root: {
        backgroundColor: 'inherit',
        minHeight: 'auto',
        height: 'auto',
        padding: 0,
        paddingLeft: Mi.spacer12,
        '&:hover': {
            '&:not(.Mui-disabled)': {
                cursor: 'default'
            }
        },
        '&$expanded': {
            minHeight: 'auto'
        }
    },
    content: {
        margin: 0,
        '&$expanded': {
            margin: 0
        }
    }
})(ExpansionPanelSummary);
const StyledExpansionPanelDetails = withStyles({
    root: {
        padding: 0,
        fontSize: Mi.baseFontSize,
        color: Mi.baseFontColor
    }
})(ExpansionPanelDetails);
const StyledOverflowDiv = styled('div') `
	white-space: ${Mi.bannerBaseContentWhiteSpace};
	overflow: ${Mi.bannerBaseContentOverflow};
	text-overflow: ${Mi.bannerBaseContentTextOverflow};
`;
const TwistyIcon = () => React.createElement("i", { className: "mi-icon-twisty-collapsed" });
export const Twisty = props => {
    const classes = useStyles(props);
    const subHeadingLabel = props.headingSubLabel ? (React.createElement("span", { id: props.id ? props.id + '-sub-header-content' : 'twisty-sub-header-content', className: classes.headingSubLabel }, props.headingSubLabel)) : null;
    const handleChange = (event, expanded) => {
        if (props.onToggleEvent) {
            props.onToggleEvent(event);
        }
        else {
            props.onToggle && props.onToggle();
        }
    };
    const getExpansionPanel = () => {
        if (typeof props.label === 'string') {
            return (React.createElement(TwistyExpansionPanel, { onChange: handleChange, defaultExpanded: props.defaultExpanded, expanded: props.isExpanded, square: true },
                React.createElement(TwistyExpansionPanelSummary, { id: props.id || 'twisty-header', className: classes.panelHeading, expandIcon: React.createElement(TwistyIcon, null), IconButtonProps: { edge: 'start' } },
                    React.createElement(StyledOverflowDiv, { id: props.id ? props.id + '-header-content' : 'twisty-header-content', "data-testid": props.id ? props.id + '-header-content' : 'twisty-header-content', className: classes.headingLabel },
                        props.label,
                        subHeadingLabel)),
                React.createElement(StyledExpansionPanelDetails, { id: props.id ? props.id + '-child-content' : 'twisty-header-child-content' }, props.children)));
        }
        else {
            return (React.createElement(StyledExpansionPanel, { onChange: handleChange, expanded: props.isExpanded },
                React.createElement(StyledExpansionPanelSummary, { id: props.id || 'twisty-header', expandIcon: React.createElement(TwistyIcon, null), IconButtonProps: { edge: 'start' } }, props.label),
                React.createElement(StyledExpansionPanelDetails, null, props.children)));
        }
    };
    return React.createElement(MuiThemeProvider, { theme: theme }, getExpansionPanel());
};
//# sourceMappingURL=Twisty.js.map